var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.933,
    height: 78.51,
    viewBox: "0 0 118.933 78.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13761",
    "data-name": "Group 13761",
    transform: "translate(-5.4 -21.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11225",
    "data-name": "Path 11225",
    d: "M32.048,82.532A32.835,32.835,0,0,1,43.254,57.851a23.157,23.157,0,0,0-9.205-5.6,14.013,14.013,0,1,0-20.278-12.54,13.857,13.857,0,0,0,7.738,12.54A21.935,21.935,0,0,0,5.9,73.193C5.9,84.266,14.171,84.8,24.844,84.8h7.6A4.313,4.313,0,0,1,32.048,82.532Z",
    transform: "translate(0 1.37)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11226",
    "data-name": "Path 11226",
    d: "M87.946,52.348a14.013,14.013,0,1,0-20.278-12.54,13.857,13.857,0,0,0,7.738,12.54,22.585,22.585,0,0,0-9.205,5.6A32.622,32.622,0,0,1,77.406,82.632a14.5,14.5,0,0,1-.133,2.4h7.471c10.673,0,18.944-.534,18.944-11.607A22.259,22.259,0,0,0,87.946,52.348Z",
    transform: "translate(20.145 1.403)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11227",
    "data-name": "Path 11227",
    d: "M53.247,99.11h8c13.875,0,24.681-.667,24.681-15.209A28.7,28.7,0,0,0,65.521,56.42a18.41,18.41,0,1,0-16.809,0A28.863,28.863,0,0,0,28.3,83.9C28.567,98.443,39.373,99.11,53.247,99.11Z",
    transform: "translate(7.484)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGroupIcon);
export default __webpack_public_path__ + "static/media/infoGroupIcon.6066d39ebf1d4e139c1e21b9e4f353c3.svg";
export { ForwardRef as ReactComponent };